// see docs/modules/insight_highlight.md#import-swiper-from-swiper
import Swiper from 'swiper';
import { A11y, Keyboard, Mousewheel } from 'swiper/modules';

(function () {
    const sliders = [...document.querySelectorAll('[data-jb-insight-slider]')];
    if (!sliders.length) return;

    sliders.forEach((slider) => {
        new Swiper(slider, {
            modules: [A11y, Keyboard, Mousewheel],
            slidesPerView: 'auto',
            spaceBetween: 0,

            // the track is a reading list, not a carousel -- nothing here moves
            // unless someone asks it to
            grabCursor: true,

            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },

            // horizontal intent only, so a trackpad swipe scrolls the row while a
            // vertical wheel still scrolls the page
            mousewheel: {
                forceToAxis: true,
            },

            a11y: {
                enabled: true,
                containerMessage: 'Insight highlights',
            },
        });
    });
})();
